import theme from './theme';

const darkTheme = {
  ...theme,

  defaultColors: {
    ...theme.defaultColors,

    background: '#0F1322',
    backgroundLight: '#141A2E',
    backgroundDark: '#0B0E1A',
    white: '#141A2E',
    light: '#1A2138',

    neutral100: '#141A2E',
    neutral200: '#161C33',
    neutral300: '#1A2138',
    neutral500: '#5A6383',

    secondary100: '#1A2138',
    secondary300: '#9AA3BE',

    primary: '#EEF1F8',
    dark: '#F5F6FA',
    richBlack: '#F5F6FA',
    black: '#EEF1F8',

    gray: '#9AA3BE',
    grey: '#9AA3BE',
    metallic: '#5A6383',

    skeletonBase: '#161C33',
    skeletonHighlight: '#1F2742',
  },
};

export default darkTheme;
